import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { licenseStatus } from '~/api/runtimeService';

type LicenseStatusVariables = {
  environment: string;
  realm: string;
  replicas: number;
  pipelineId: string;
  size: string;
};

export const useLicenseStatus = () => {
  const queryClient = useQueryClient();

  const fetchLicenseStatus = useCallback(
    (variables: LicenseStatusVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'licenseStatus',
          variables.realm,
          variables.environment,
          variables.pipelineId,
          variables.size,
          variables.replicas
        ],
        queryFn: () => licenseStatus(variables),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { fetchLicenseStatus };
};
